import axiosInstance from '../utils/axiosConfig';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import {
    ISiteAttendanceDay,
    ISiteAttendanceClockRequest,
    ISiteAttendanceRow,
} from '../interface/SiteAttendance';

const readError = (error: unknown, fallback: string): string => {
    if (error instanceof AxiosError) return error.response?.data?.message || fallback;
    if (error instanceof Error) return error.message || fallback;
    return fallback;
};

// Everyone assigned to the site on that day, clocked or not.
export const fetchSiteAttendance = async (
    siteId: number,
    date: string
): Promise<ISiteAttendanceDay> => {
    try {
        const response = await axiosInstance.get('/Personel/site-attendance', {
            params: { siteId, date },
        });

        if (!response.data.success) {
            throw new Error(response.data.message || 'Failed to fetch site attendance');
        }

        return response.data.data;
    } catch (error) {
        const message = readError(error, 'An unexpected error occurred while fetching site attendance.');
        toast.error(message);
        throw error;
    }
};

/**
 * Clocks someone in or out on their behalf. Leave `time` empty to record the
 * current time at the site. The server stamps who did it onto the timesheet.
 */
export const clockSitePersonnel = async (
    request: ISiteAttendanceClockRequest
): Promise<ISiteAttendanceRow | null> => {
    try {
        const response = await axiosInstance.post('/Personel/site-attendance/clock', request);

        if (!response.data.success) {
            throw new Error(response.data.message || 'Failed to record the clock');
        }

        toast.success(response.data.message || 'Recorded successfully');
        return response.data.data ?? null;
    } catch (error) {
        const message = readError(error, 'An unexpected error occurred while recording the clock.');
        toast.error(message);
        throw error;
    }
};
